// extracted by mini-css-extract-plugin
export default {"tupacGrid":"po-z","tupacHeader":"qo-z","tupacHeader2":"ro-z","tupacMenu":"so-z","tupacMenu2":"to-z","tupacMain":"uo-z","tupacMain2":"vo-z"};